<template>
    <BagManagementCore :key="bagId" :bag-id="bagId"/>
</template>
<script>
    import BagManagementCore from './BagManagementCore.scp.html'

    export default {
        props: ['bagId'],
        mounted() {
            console.log("[BagManagement] Parent Mounted")
        },
        components: {
            BagManagementCore
        }
    }
</script>




// WEBPACK FOOTER //
// BagManagement.scp.html?1e22ab04